import PropTypes from "prop-types"

const ServiceSelectorContent = ({
  serviceName,
  contentServiceName,
  contentServiceIcon,
}) => {
  return (
    <div>
      {contentServiceName ? (
        <img src={contentServiceIcon} alt={contentServiceName} />
      ) : (
        <div>
          Choose a service to see how {serviceName} is connecting with different
          services.
        </div>
      )}
    </div>
  )
}

ServiceSelectorContent.propTypes = {
  serviceName: PropTypes.string.isRequired,
  contentServiceName: PropTypes.string,
  contentServiceColor: PropTypes.string,
  contentServiceIcon: PropTypes.string,
}

export default ServiceSelectorContent
